<template>
    <div class="container mx-auto px-8" v-if="affiliate && affiliate.formkit_schema">
        <FormKit
            type="form"
            @submit="submit"
            v-model="data"
            v-if="affiliate?.formkit_schema?.length > 0 && !submitted"
        >
            <FormKitSchema :schema="schema" />
        </FormKit>
        <p v-if="submitted">Thank you for submitting!</p>
    </div>
    <div class="text-center mt-auto" v-if="affiliate && affiliate.formkit_schema">
        <a
            :href="`/sign-up/${affiliate.short_uuid}`"
            class="text-blue-500 hover:text-blue-700"
            >Sign Up as an Affiliate</a
        >
    </div>
</template>

<script setup>
import { FormKit, FormKitSchema } from "@formkit/vue";
import { usePage, router } from "@inertiajs/vue3";
import { computed, ref } from "vue";

const page = usePage();
const affiliate = computed(() => page.props.affiliate);
const schema = computed(() => JSON.parse(affiliate?.value?.formkit_schema));
const data = ref({});

const submitted = ref(false);

const submit = () => {
    router.post(window.location.href, data.value, {
        headers: {
            "X-CSRF-Token": page.props.csrfToken,
        },
        onSuccess: () => {
            submitted.value = true;
        },
    });
};
</script>
